<template>
  <div class="page page-news-list">
    <div class="page__wrap" data-animate="page-wrap">
      <div
        class="row-1 p-top-3"
        :class="{
          'p-bot-3': !list.length,
          'm-bot-5': list.length,
        }"
      >
        <header>
          <h1 data-animate="header-title" class="title-xl">{{ news.title }}</h1>
        </header>
        <ListingFiltersButtonsRounded
          data-animate="header-content"
          class="m-top-5"
          :families="familiesForFilters"
          @selected="onFilterSelected"
        />
      </div>
      <!-- List -->
      <PagesNewsList
        v-if="list.length"
        class="row-1 m-top-4"
        :news="list"
        :class="{
          'p-bot-3': count <= limit,
        }"
        v-anim-parallax-element="{
          target: 'picture',
          offset: 10,
        }"
      />

      <WidgetPaginationListing
        v-if="count > limit"
        class="row-1 flex --justify-center m-top-3 p-bot-3"
        :itemPerPage="limit"
        :total="count"
      />
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import newsFilters from '@/bucket/news-filters.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Ottieni la configurazione dal tuo store personalizzato
const { configuration } = useCraftStore()
const route = useRoute()
const { t } = useI18n()

const selectedCategories = ref(route.query?.categories || [])

// Fetch Data
const query = queries.news.getNewsList

const limit = ref(10)

const variables = computed(() => ({
  site: configuration.site,
  limit: limit.value,
  marketId: configuration.marketId,
  newsType: selectedCategories.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,
}))
const { data } = await useGraphql(query, variables)

if (!data.value?.newsHomeEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const news = computed(() => data.value?.newsHomeEntries?.[0])
const list = computed(() => data.value.newsEntries)
const count = computed(() => data.value?.entryCount || 0)
const seo = computed(() => data.value?.newsHomeEntries?.[0]?.seo || {})

const familiesForFilters = newsFilters.map((filter) => ({
  id: filter,
  title: t(`filters.${filter === 'all' ? 'allNews' : filter}`),
}))

// Quando seleziono un filtro
const onFilterSelected = (selected) => {
  selectedCategories.value = selected
}

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
